const PageMessages = {
    sei: {
        propostaIndicador: {
            enviarParaAnaliseNegocial:
                'Sua Proposta [Número: "{NUMERO}" Nome: "{NOME}"] foi enviada e será analisada em breve!',
            termosObrigatorios: 'Você deve aceitar os termos de consentimento para prosseguir.',
            instrumentoEmpty: 'Informar o Instrumento',
            tipoPropostaAlterar:
                'Esta é uma proposta de alteração de Indicador, e só pode ser editada pela tela de "Indicadores"',
            tipoPropostaCancelar:
                'Esta é uma proposta de alteração de Indicador, e só pode ser cancelada pela tela de "Indicadores"',
            tipoPropostaExcluir:
                'Esta é uma proposta de alteração de Indicador, e só pode ser excluída pela tela de "Indicadores"',
            cancelar: 'Tem certeza que deseja prosseguir com o Cancelamento desse registro?',
            vinculoRequired:
                'Para prosseguir é necessário que a proposta tenha ao menos um vínculo.',
            findModalRequiredInputs:
                'Para confirmar é necessário selecionar ao menos um registro na lista',
            termosConsentimento:
                'Para indicadores novos, sem historicidade, é necessário certificar-se da existência dos dados para cálculo e iniciar a série histórica com o marco inicial zero (0), no campo valor apurado',
            inputs: {
                descArea: 'Indicar o setor e área de atuação.',
                responsavelIndicador: 'Apontar o nome do responsável pelo indicador.',
                instrumento:
                    'Eixo/Programa/Ação/Macroprocesso/Processo/Subprocesso/Projeto/Gestão, outros',
                nmIndicador:
                    'Apontar o nome do indicador. Deve ser sucinto, comunicável e escrito de forma que, ao lê-lo, tenha-se uma visão clara do que o indicador pretende mensurar.',
                descJustificativa: 'Descrever a justificativa: programa/processo/projeto/gestão.',
                descObjetivo:
                    'Descrever o objetivo para o qual foi desenvolvido o indicador. programa/processo/projeto/gestão.',

                unidadeMedida: 'Indicar o padrão utilizado para mensuração da relação adotada.',
                descMetodologia:
                    'Apresentar a fórmula matemática que representa o modo de calcular do indicador, a partir das suas variáveis. No caso de indicadores que são disponibilizados diretamente por órgãos oficiais, este campo deverá ser preenchido apenas com a variável disponível, que será o próprio indicador.',
                descInterpretacaoUso:
                    'Fazer a descrição: "O que ele é?" Refere-se a descrição da fórmula de cálculo.  Interpretação e Uso: "O que ele faz e para que serve?"',
                fontes: 'Indicar o(s) Órgão(s) responsável(is) pelo registro ou produção das informações necessárias para a apuração do indicador.',
                descPesquisaDados:
                    'Descrever a forma de coleta de dados. Caso não haja uma pesquisa para obtenção da informação, considera-se como registro administrativo.',
                periodicidadeIndicador: 'Indicar a periodicidade de disponibilização do indicador.',
                desagregacaoGeografica: 'Apontar a desagregação territorial.',
                desagregacaoCategorica: 'Classificar categoricamente o dado.',
                descInformacaoComplementar:
                    'Informações Complementares - Descrever normas ou definições ou complementares.    ',
                descLimitacao:
                    'Limitação - Descrever aspectos ligados à composição e aplicação do indicador que possam restringi-lo de alguma forma.',
                descRecomendacao:
                    'Recomendação - Apontar fatores como: possíveis falhas, erros de interpretação e outros aspectos que sejam considerados importantes na análise do indicador.',
                compreensaoResultado:
                    'Classificar quanto ao sentido: "Quanto maior, melhor” ou “quanto maior pior."',
                descParametroComparacao:
                    'Descrever o valor de referência tomado para estipular as metas.',
                concordaTermo:
                    'Para indicadores novos, sem historicidade, é necessário certificar-se da existência dos dados para cálculo e iniciar a série histórica com o marco inicial zero (0), no campo valor apurado.',
                dataReferencia:
                    'Preencher a série histórica do indicador:  Informar os valores apurados anteriores e respectivas datas de apuração.',
            },
        },
        analiseMetodologica: {
            confirmFinnaly: 'Deseja Finalizar a Análise Metodológica?',
            successOnFinnaly:
                'O Indicador Código [{CODIGO}] e Nome [{NOME}] foi gerado com sucesso, e ja se encontra disponível para uso!',
            valid: 'É obrigatório selecionar ao menos um dos três checks referente a Validação metodológica do indicador.',
        },
        analiseNegocial: {
            confirmFinnaly: 'Deseja Finalizar a Análise Negocial?',
            successOnFinnaly: 'Análise Negocial Finalizada com Sucesso!',
        },
        indicador: {
            confirmAlter: 'Deseja solicitar uma proposta de alteração do presente indicador?',
            successOnInactivate: 'Solicitação de {TIPO} registrada com sucesso!',
            solicitacaoInativacao: {
                partialMessages: [
                    'O Presente indicador ja contem uma solicitação',
                    'A  mesma encontra-se pendente',
                ],
            },
        },
        metasResultados: {
            inclusaoNaoPermitida:
                'A situação do respectivo indicador é diferente de "Ativo", portanto não será possível a inclusão de meta para o mesmo!',
            alteracaoNaoPermitida:
                'A situação do respectivo indicador é diferente de "Ativo", portanto não será possível alterar a respectiva meta!',
            confirmEnvio: 'Deseja Enviar a Meta para a Analise Negocial?',
            apurarResultado: {
                apuracaoExistente:
                    'A presente meta, ja possui lançamento de "Apuração de Resultado"',
                metaNaoValidada:
                    'A Situação da presente Meta selecionada é diferente de "Validada" portanto não será possível a "Apuração de Resultado" da mesma.',
                indicadorNaoAtivoApuracaoAvulsa:
                    'A situação do respectivo indicador é diferente de "Ativo", portanto não será possível a inclusão de "Outras Apurações do Indicador"',
                indicadorNaoAtivo:
                    'A situação do respectivo indicador é diferente de "Ativo", portanto não será possível a inclusão apuração de Resultado da Meta para o mesmo!',
            },
        },
        analisePropostaMeta: {
            indicadorNaoAtivo:
                'A situação do respectivo indicador é diferente de "Ativo", portanto não será possível realizar a Analise da respectiva Meta!',
        },
    },
};

export default PageMessages;
